import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import CreditCardUpdateForm from './CreditCardUpdateForm'
import { UpdatePaymentDto } from '../@types/UpdatePaymentDto'
import { getBaseURL } from '../GlobalComponents/URLs'

export default function CreditCard() {
    const [submitting, setSubmitting] = useState(false)
    const urlParams = useParams()
    const [cvv, setCvv] = useState(urlParams.cvv!)
    let expiration = urlParams.expirationDate!
    expiration = expiration.substring(0, 2) + '/' + expiration.substring(4)
    const [expirationDate, setExpirationDate] = useState(expiration)
    const [error, setError] = useState('')
    const [isCvvOk, setCvvOk] = useState(false)
    const [isExpirationDateOk, setExpirationDateOk] = useState(false)

    const creditCardServiceUrl = `${getBaseURL()}webapics/api/v1/paymentmethod`

    function submit(event: any) {
        event.preventDefault()
        let month = expirationDate.substring(0, 2)
        let year = '20' + expirationDate.substring(3)
        const updatePaymentDto: UpdatePaymentDto = {
            Token: urlParams.token!,
            CVV: cvv,
            ExpirationYear: year,
            ExpirationMonth: month,
        }
        SendPaymentInfo(updatePaymentDto)
    }

    function handleCVVchange(event: any) {
        let cvv: string = event.target.value
        setCvv(cvv)
        if (cvv.length <= 4) {
            setCvvOk(true)
        } else {
            setCvvOk(false)
        }
        if (isCvvOk && isExpirationDateOk) {
            setSubmitting(true)
        }
    }

    function handleCancel() {
        window.location.replace(`${getBaseURL()}PaymentMethods.aspx`)
    }
    function handleExpirationDateChange(event: any) {
        let textTemp = event.target.value
        if (!isCvvOk || !isExpirationDateOk) {
            setSubmitting(false)
        }
        if (textTemp[0] !== '1' && textTemp[0] !== '0') {
            textTemp = ''
        }
        if (textTemp.length === 2) {
            if (
                parseInt(textTemp.substring(0, 2)) > 12 ||
                parseInt(textTemp.substring(0, 2)) === 0
            ) {
                textTemp = textTemp[0]
            } else if (textTemp.length === 2 && expirationDate.length < 2) {
                textTemp += '/'
            } else {
                //textTemp = textTemp[0];
            }
        }
        if (textTemp.length > 3 && textTemp.length < 6) {
            if (parseInt(textTemp.substring(3)) < 99) {
                //textTemp = textTemp[0]
            } else {
                textTemp = textTemp.substring(0, 2)
            }
        }
        if (textTemp.length === 3) {
            if (textTemp.substring(2, 2) !== '/') {
                textTemp = textTemp.substring(0, 2) + '/'
            }
        }
        if (textTemp.length > 5) {
        } else {
            setExpirationDate(textTemp)
            setExpirationDateOk(true)
            if (isCvvOk && isExpirationDateOk) {
                setSubmitting(true)
            }
        }
    }

    async function SendPaymentInfo(updatePaymentDto: UpdatePaymentDto) {
        let company: string = urlParams.database!
        setSubmitting(false)
        setError('') //#6902 don't show Sending Information
        await fetch(creditCardServiceUrl, {
            method: 'PUT',
            mode: 'cors',
            headers: {
                'content-type': 'application/json',
                company: company,
            },
            body: JSON.stringify(updatePaymentDto, [
                'Token',
                'ExpirationYear',
                'ExpirationMonth',
                'CVV',
                'CustomerId',
            ]),
        })
            .then((response) => {
                if (response.ok) {
                    let url = `${getBaseURL()}PaymentMethods.aspx?update=1`
                    window.location.replace(url)
                } else {
                    setError('We had an issue calling the server')
                }
            })
            .catch((error) => {
                setError('We had an issue with the server')
            })
    }

    return (
        <CreditCardUpdateForm
            submmiting={submitting}
            handleClick={(e) => submit(e)}
            creditCardType={urlParams.name!}
            cvv={cvv}
            handleCVVchange={(e) => handleCVVchange(e)}
            cardName={urlParams.name!}
            last4Number={urlParams.last4!}
            expirationDate={expirationDate}
            handleExpirationDateChange={(e) => handleExpirationDateChange(e)}
            handleCancel={handleCancel}
            error={error}
        />
    )
}
